import {
  type IconType,
  ListItem,
  ListItemIcon,
  ListItemText,
  Text,
} from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { formatDollarsAsUsd } from "@src/appV2/lib/Money/utils/currency";

import {
  NegotiationHistoryAction,
  NegotiationRateRole,
  type RateNegotiationHistoryResponse,
} from "../types";
import { formatNegotiationDate } from "../utils";

interface PayProps {
  history: RateNegotiationHistoryResponse;
}

function getIconType(history: RateNegotiationHistoryResponse): IconType {
  if (history.createdByUserRole === NegotiationRateRole.WORKPLACE) {
    return "briefcase";
  }

  return "user";
}

export function ListItemRateNegotiationHistory(props: PayProps) {
  const { history } = props;

  const { payRate, createdByUserRole, action, createdAt } = history;

  return (
    <ListItem divider>
      <ListItemIcon iconType={getIconType(history)} />
      <ListItemText
        disableTypography
        primary={
          <Stack direction="row" spacing={3} alignItems="center" justifyContent="space-between">
            {createdByUserRole === NegotiationRateRole.WORKER && isDefined(payRate) && (
              <Text semibold variant="h6">
                You proposed {formatDollarsAsUsd(payRate)}/hr
              </Text>
            )}
            {createdByUserRole === NegotiationRateRole.WORKPLACE &&
              action === NegotiationHistoryAction.REJECTED && (
                <Text semibold variant="h6">
                  Workplace rejected
                </Text>
              )}
            {createdByUserRole === NegotiationRateRole.WORKPLACE &&
              action === NegotiationHistoryAction.PROPOSED &&
              isDefined(payRate) && (
                <Text semibold variant="h6">
                  Workplace proposed {formatDollarsAsUsd(payRate)}/hr
                </Text>
              )}

            {createdByUserRole === NegotiationRateRole.ADMIN &&
              action === NegotiationHistoryAction.BOOKED_CONFLICTING_SHIFT && (
                <Text semibold variant="h6">
                  System closed negotiation due to conflicting shift
                </Text>
              )}

            <Text variant="body2">{formatNegotiationDate(createdAt)}</Text>
          </Stack>
        }
      />
    </ListItem>
  );
}
